import { forwardRef } from 'react';
import styled from 'styled-components';
import { Icon, type IconProps } from '../../Icons/Icon';
import type { IconName } from '../../Icons/IconNames';
import { IconButtonWrapper, type IconButtonWrapperProps } from './styles';

export interface IconButtonProps extends IconButtonWrapperProps {
  icon: IconName;
  iconSize?: IconProps['size'];
}

export const IconButton = styled(
  forwardRef<HTMLButtonElement, IconButtonProps>(({ icon, iconSize, variant, color, ghost, ...props }, ref) => (
    <IconButtonWrapper {...props} ref={ref} variant={ghost ? undefined : variant} ghost={ghost}>
      <Icon icon={icon} variant={ghost ? variant : undefined} color={color} size={iconSize} />
    </IconButtonWrapper>
  ))
)``;
